import script from "./TranslatorApply.vue?vue&type=script&setup=true&lang=js"
export * from "./TranslatorApply.vue?vue&type=script&setup=true&lang=js"

import "./TranslatorApply.vue?vue&type=style&index=0&id=16e04354&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-16e04354"]])

export default __exports__